module.exports = __webpack_public_path__ + "static/media/change-my-mind.4ce9a55e.png";